<template>    
    <b-container class="text-center transaction-details">                            
        <h1>
            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        </h1>
        <!-- <button class="btn btn-primary" id="go-sell">Proceed to Payment</button> -->
        <div id="wrap-content"></div>
    </b-container>    
</template>
<style lang="scss" scoped>
    .transaction-details{
        height: 100%;
        vertical-align: middle;
        margin-top: 200px; 
        #wrap {
            iframe {
                &#gosell-gateway{
                    display: block !important;
                }
            }
            .content {
                text-align: center;
                .title{
                    color: var(--main-color);
                    margin-bottom: 20px;
                }
                .btn {
                    border: 1px solid var(--main-color);
                    color: var(--main-color);
                    width: 90%;
                    margin-bottom: 20px;
                }
            }       
        }
    }
</style>
<script>
import { mapGetters, mapMutations } from "vuex";
import { TranslationMixin } from '@/mixins'
import { Payment, Concept } from '@/services/SOLO'
export default {
    data() {
        return {
            isConfiguring: true,
            redirectURL: window.location.hostname + `/pay/redirect`,
            goSellCdn: null,
            publicKey: null
        };
    },
    mixins: [TranslationMixin],
    computed: {
        ...mapGetters({
            getTapOrderID: "app/getTapOrderID",
            getConcept: "concept/getConcept",
            getTapOrderAmount: "app/getTapOrderAmount",
            getUser: "account/getUser",
            getTapPaymentStatus: 'app/getTapPaymentStatus',
            getTapCredentials: 'app/getTapCredentials',
            getLocation: 'cart/getLocation',
            getKioskOrder: 'app/getKioskOrder'
        }),
        customer() {
            return {
                customer: {
                    id: null,
                    first_name: 'Kiosk',
                    last_name: 'Payment',
                    phone: {
                        country_code: this.getConcept.attributes["dialing-code"],
                        number: this.removeMobilePrefix(966535849161)
                    }
                }
            };
        },
        gatewayDetails() {
            let details = {
                publicKey: this.publicKey,
                language: "en",
                contactInfo: true,
                supportedCurrencies: "all",                
                saveCardOption: false,
                customerCards: true,
                notifications: "standard",
                supportedPaymentMethods:  "all",
                tap_merchant_id: 'test123'
            };

            
            
            return details;
        },
        styles() {
            return {
                backgroundImg: {
                    url: this.getConcept.attributes["logo-uri"],
                    opacity: "1.0"
                },
                labels: {
                    cardNumber: "Card Number",
                    expirationDate: "MM/YY",
                    cvv: "CVV",
                    cardHolder: "Name on Card",
                    actionButton: "Pay"
                },
                style: {
                    base: {
                        color: "#535353",
                        lineHeight: "18px",
                        fontFamily: "sans-serif",
                        fontSmoothing: "antialiased",
                        fontSize: "16px",
                        "::placeholder": {
                            color: "rgba(0, 0, 0, 0.26)",
                            fontSize: "15px"
                        }
                    },
                    invalid: {
                        color: "red",
                        iconColor: "#fa755a "
                    }
                }
            };
        }
    },
    mounted() {                  

        if(this.$route.query.order && this.$route.query.order != '') {
            this.setTapPaymentResponse(null)
            this.setKioskVerifyResponse(null)
            this.setKioskOrder(null)
            this.kioskPaymentOrder(this.$route.query.order)            
        } 
    },    
    methods: {
        ...mapMutations({
            setTapPaymentStatus: 'app/setTapPaymentStatus',
            setKioskOrder: 'app/setKioskOrder',
            setTapPaymentResponse: 'app/setTapPaymentResponse',
            setKioskVerifyResponse: 'app/setKioskVerifyResponse',
            setToken: 'app/setToken'
        }),
        getTapPublicKey(params) {
            Concept.getTapPublicKey().then(response => {
                this.publicKey = response.data.data.option_value
                this.redirectURL = (window.location.hostname.includes('localhost') ? 'http://localhost:8080' : 'https://' + window.location.hostname )+ "/pay/redirect"                            
                console.log(this.publicKey)
                console.log(this.setConfig())
                goSell.config(this.setConfig())                 
                setTimeout(()=> {
                    goSell.openPaymentPage()
                },2000)
            });
        },
        kioskPaymentOrder(orderId) {
            this.setToken(orderId)
            Payment.kioskPaymentOrder(orderId).then(response => {
                this.setKioskOrder(response.data.data)
                this.getTapPublicKey()   
            }).catch(err => {
                console.log(err.response)
            })
        },     
        setConfig() {            
            return {
                containerID: "wrap-content",
                gateway: {
                    ...this.gatewayDetails,
                    callback: response => {
                        this.isConfiguring = false                        
                    },
                    onClose: () => {
                        console.log("onClose Event");
                    },
                    ...this.styles
                },
                ...this.customer,
                order: {
                    amount: this.getKioskOrder.attributes.order.total,
                    currency: this.getConcept.attributes["currency-code"],
                    items: [],
                    shipping: null,
                    taxes: null
                },
                transaction: {
                    mode: "charge",
                    charge: {
                        saveCard: false,
                        threeDSecure: true,
                        description: "Test Description",
                        statement_descriptor: "Sample",
                        reference: {
                            transaction: this.setTransaction(),
                            order: this.getKioskOrder.attributes.order.id
                        },
                        metadata: {},
                        receipt: {
                            email: false,
                            sms: true
                        },
                        redirect: this.redirectURL,
                        post: process.env.VUE_APP_API_URL + `/webhook/tap/feedback`
                    }
                },
            };
        },
        setTransaction() {
            var d = new Date();
            return d.getTime() + this.getKioskOrder.id;
        },
        removeMobilePrefix(mobile) {
            let formattedMobile = mobile.toString();
            return formattedMobile.substring(3, formattedMobile.length);
        }
    }
};
</script>